import {
  AfterContentInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
  input,
  Signal,
  computed,
} from '@angular/core';
import { ServiceModel } from '@app/src/app/modules/service/classes/default/model/service.model';
import {
  PROVIDER_NAMES,
  RenderHtml,
  Translation,
} from '@ckmk/angular';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'service-card',
  standalone: true,
  imports: [Translation, RenderHtml, RouterLink, FaIconComponent],
  templateUrl: './service-card.html',
  styleUrl: './service-card.scss',
  host: {
    '[style]': 'styles()',
  },
  encapsulation: ViewEncapsulation.None,
})
export class ServiceCard
  implements OnInit, OnChanges, OnDestroy, AfterContentInit
{
  protected readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly icons = inject(PROVIDER_NAMES.ICONS);

  public readonly item = input.required<ServiceModel>();

  protected readonly styles: Signal<any> = computed<any>(() => {
    const item = this.item();
    const styles: any = {};

    const leftColor = item.category?.data?.leftColor;
    const rightColor = item.category?.data?.rightColor;

    if (leftColor && rightColor) {
      styles['--color-category-left'] = leftColor;

      styles['--color-category-right'] = rightColor;
    }

    return styles;
  });

  protected readonly imgPath: Signal<string> = computed<string>(
    () => this.item().picture?.defaultUrl || '',
  );

  public constructor() {}

  public ngOnInit() {}

  public ngOnChanges({ item }: SimpleChanges) {}

  public ngOnDestroy() {}

  public ngAfterContentInit() {}
}
